export default "<app-glasses-list [glassesType]=\"'eyeglasses'\" [gender]=\"gender\"></app-glasses-list>"